var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.077,
    height: 73.066,
    viewBox: "0 0 85.077 73.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffa03b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.951,36.1l3.336-4.671L23.111,16.247H-2.412v5.338H20.275ZM73.991,21.585l-6.339,5.672q-1.668,1.5-.334,2.836l.5.667a1.839,1.839,0,0,0,2.836,0l10.676-9.675L82,20.417a1.84,1.84,0,0,0,0-2.836l-.667-.667L70.487,7.072a1.839,1.839,0,0,0-2.836,0l-.5.667q-1.335,1.168.334,2.669l6.339,5.839H54.473L20.275,64.29H-2.412v5.338H23.111L57.142,21.585Zm7.34,43.373L70.487,55.115a1.839,1.839,0,0,0-2.836,0l-.5.667q-1.335,1.168.334,2.669l6.339,5.839H57.142L47.633,49.443,44.3,54.114,54.473,69.628H73.991L67.651,75.3q-1.668,1.5-.334,2.836l.5.667a1.839,1.839,0,0,0,2.836,0l10.676-9.675L82,68.461a1.84,1.84,0,0,0,0-2.836Z",
    transform: "translate(2.412 -6.404)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.a0e4a54c913848f5e85533b2b1461a41.svg";
export { ForwardRef as ReactComponent };